import $http from "../../../axios";
import { Notification } from "element-ui";

/**
 * Obtener exclusiones
 */
export async function fetchExclusions({ commit }, params) {
  await $http
    .get("/api/statistics-product-sale-client-exclusions", { params })
    .then((response) => {
      commit("setExclusions", response.data.data);
    })
    .catch((error) => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box",
      });
    });
}

/**
 * Crear exclusión
 */
export async function createExclusion({ commit }, payload) {
  await $http
    .post("/api/statistics-product-sale-client-exclusions", payload)
    .then((response) => {
      commit("addExclusion", response.data.data);

      Notification.success({
        title: "Éxito",
        message: "Producto Excluido correctamente",
        type: "success",
        duration: 1500,
        customClass: "notification-box",
      });
    })
    .catch((error) => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box",
      });
    });
}

/**
 * Actualizar exclusión
 */
export async function updateExclusion({ commit }, { id, data }) {
  await $http
    .put(`/api/statistics-product-sale-client-exclusions/${id}`, data)
    .then((response) => {
      commit("updateExclusion", response.data.data);

      Notification.success({
        title: "Éxito",
        message: "Exclusión actualizada correctamente",
        type: "success",
        duration: 1500,
        customClass: "notification-box",
      });
    })
    .catch((error) => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box",
      });
    });
}

/**
 * Eliminar exclusión
 */
export async function deleteExclusion({ commit }, id) {
  await $http
    .delete(`/api/statistics-product-sale-client-exclusions/${id}`)
    .then(() => {
      commit("removeExclusion", id);

      Notification.success({
        title: "Éxito",
        message: "Exclusión eliminada correctamente",
        type: "success",
        duration: 1500,
        customClass: "notification-box",
      });
    })
    .catch((error) => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box",
      });
    });
}



// WEBPACK FOOTER //
// ./src/b2b/modules/statistics-product-sale-client-exclusion/actions.js